var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSocialTwitter = function SvgSocialTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#00FF51"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.944 12.738c.013.164.013.328.013.492 0 5.004-4.124 10.77-11.663 10.77-2.322 0-4.48-.621-6.294-1.7.33.036.647.048.99.048 1.916 0 3.68-.598 5.089-1.617-1.802-.036-3.313-1.126-3.833-2.626.254.036.508.059.774.059.368 0 .736-.047 1.079-.129-1.878-.351-3.287-1.875-3.287-3.715v-.047c.546.282 1.18.457 1.853.48-1.104-.679-1.827-1.839-1.827-3.152 0-.703.203-1.347.558-1.91 2.018 2.297 5.05 3.797 8.452 3.961a3.961 3.961 0 0 1-.102-.867c0-2.086 1.828-3.785 4.1-3.785 1.18 0 2.245.457 2.994 1.195a8.486 8.486 0 0 0 2.602-.914c-.305.88-.952 1.617-1.802 2.086a8.761 8.761 0 0 0 2.36-.586 8.478 8.478 0 0 1-2.056 1.957Z",
    fill: "#000"
  })));
};

export default SvgSocialTwitter;